import { SxProps, Theme, Typography, TypographyProps } from '@mui/material';

const BASE_SX: SxProps<Theme> = {
  fontSize: '0.8rem',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  overflowWrap: 'anywhere',
};

export const AttributeText = ({ sx, ...props }: TypographyProps) => (
  <Typography variant="body2" sx={{ ...BASE_SX, ...sx }} {...props} />
);
